import {IconDone} from '@sportcast/ui-react';
import {CookieConsent} from 'react-cookie-consent';
import {Trans, useTranslation} from 'react-i18next';
import './CookieBanner.scss';

export const CONSENT_TECHNICAL_COOKIES = 'CONSENT_TECHNICAL_COOKIES';

interface ConsentProps {
    onDataPrivacyClick?: (show: boolean) => void;
}

function CookieBanner(props: ConsentProps = {}) {
    const [t] = useTranslation();
    return (
        <CookieConsent
            location="bottom"
            buttonText={<span className="button-content">
                <IconDone className="button-icon"/>{t('Consent.BUTTON_TEXT')}</span>}
            declineButtonText={t('Consent.DECLINE_BUTTON_TEXT')}
            cookieName={CONSENT_TECHNICAL_COOKIES}
            expires={300}
            contentClasses="consent-content"
            buttonWrapperClasses="consent-buttons"
            buttonClasses="consent-button"
        >
            <p className="consent-text">
                <Trans i18nKey="Consent.TEXT" components={{
                    1: <button className="button-link"
                               onClick={() => props.onDataPrivacyClick?.(true)}/>
                }}/>
            </p>
        </CookieConsent>
    );
}

export default CookieBanner;
